import React from "react";

export const About = () => {
  return (
    <section name="about" className="w-full bg-transparent py-20">
      <div className="max-w-[1240px] mx-auto px-4 text-center">
        <h2 className="text-5xl py-1 mb-2 font-bold text-white">
          About Valiant
        </h2>
        <div className="mb-4 md:mb-8 p-8 rounded-xl bg-white/10 backdrop-blur-lg border border-white/20 shadow-xl hover:shadow-2xl transition-all duration-500">
          <p className="text-3xl py-2 md:py-4 text-white font-semibold">
            What is Valiant?
          </p>
          <p className="text-xl md:text-2xl text-gray-100 mt-2 leading-relaxed">
            Valiant is a technology startup that identified a fundamental flaw in how investment research operates: despite the industry's sophistication, its research process remains fragmented and manual, with highly skilled analysts spending most of their time on low-value tasks. Rather than simply adding another tool to an already cluttered workflow, Valiant aims to transform the entire research process through intelligent automation with bank-level security.
          </p>
        </div>
        <div className="mb-4 md:mb-8 p-8 rounded-xl bg-white/10 backdrop-blur-lg border border-white/20 shadow-xl hover:shadow-2xl transition-all duration-500">
          <p className="text-3xl py-2 md:py-6 text-white font-semibold">
            What is the Product
          </p>
          <p className="text-xl md:text-2xl text-gray-100 mt-2 leading-relaxed">
            Valiant is developing an AI-powered research platform that, for the first time, unifies the entire investment research process into a continuous, self-improving cycle. A living research ecosystem that augments researchers rather than just another traditional software tool.
          </p>
        </div>
        <div className="my-8 py-5 text-center">
                     <button
            className="py-2 px-2 md:px-4 text-md md:text-2xl text-white bg-transparent backdrop-blur-sm border-[2.5px] border-white rounded-lg hover:bg-white hover:text-gray-800 transition-all duration-300"
            onClick={() => { window.location.href = "mailto:info@valiantintelligence.com" }}
          >
            Contact us for more info
          </button>
        </div>
      </div>
    </section>
  )
}
